import type { SortDirection } from "../components/custom-table/types";

interface SortIconProps {
  /** True when this column is the active sort column. */
  active: boolean;
  /** Current sort direction (only meaningful when `active`). */
  direction: SortDirection;
}

/**
 * Column sort indicator. Shows both chevrons dimmed when inactive, and a single
 * chevron matching the active direction otherwise.
 *
 * @param props - {@link SortIconProps}
 * @returns The sort indicator glyph
 */
export function SortIcon({ active, direction }: SortIconProps) {
  if (!active) {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ opacity: 0.4 }} aria-hidden="true">
        <path d="M8 4L11 7H5L8 4Z" fill="currentColor" />
        <path d="M8 12L11 9H5L8 12Z" fill="currentColor" />
      </svg>
    );
  }
  return direction === "asc" ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M8 4L11 7H5L8 4Z" fill="currentColor" />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M8 12L11 9H5L8 12Z" fill="currentColor" />
    </svg>
  );
}

export default SortIcon;
